<template>
  <div id="app">
    <keep-alive>
       <router-view v-if='$route.meta.keepAlive'></router-view>
    </keep-alive>
    <router-view v-if='!$route.meta.keepAlive'></router-view>
    <div class="quickEntry">
      <a v-show="showIconFlag" href="javascript:void(0);" :class="activeIndex === 0 ? 'activeA': ''" @mouseover="showText(0)" @mouseout="hideText()" @click="openCompareBox">
        <span>PK</span>
        <p :class="activeIndex === 0 ? 'showP': 'hideP'">加入对比</p>
        <i v-if="compareGoodNum > 0 ">{{compareGoodNum}}</i>
      </a>
      <a v-show="showIconFlag" href="/#/cart/detail" target="_blank" :class="activeIndex === 1 ? 'activeA': ''" @mouseover="showText(1)" @mouseout="hideText()">
        <img v-if="activeIndex === 1" src="./assets/PageCommon/img/quickEntryIcon/cart1.png">
        <img v-else src="./assets/PageCommon/img/quickEntryIcon/cart.png">
        <p :class="activeIndex === 1 ? 'showP': 'hideP'">购物车</p>
        <i v-if="cartGoodNum > 0 ">{{cartGoodNum > 99? '99+' : cartGoodNum}}</i>
      </a>
      <a v-show="showIconFlag" href="/#/member/order/0" target="_blank" :class="activeIndex === 2 ? 'activeA': ''" @mouseover="showText(2)" @mouseout="hideText()">
        <img v-if="activeIndex === 2" src="./assets/PageCommon/img/quickEntryIcon/order1.png">
        <img v-else src="./assets/PageCommon/img/quickEntryIcon/order.png">
        <p :class="activeIndex === 2 ? 'showP': 'hideP'">我的订单</p>
      </a>
      <a v-show="showIconFlag" href="/#/news/article?id=31" target="_blank" :class="activeIndex === 3 ? 'activeA': ''" @mouseover="showText(3)" @mouseout="hideText()">
        <img v-if="activeIndex === 3" src="./assets/PageCommon/img/quickEntryIcon/ads1.png">
        <img v-else src="./assets/PageCommon/img/quickEntryIcon/ads.png">
        <p :class="activeIndex === 3 ? 'showP': 'hideP'">支持小组</p>
      </a>
       <a v-show="showIconFlag" href="https://qm.qq.com/q/xG6ZrnOyae" target="_blank" :class="activeIndex === 5 ? 'activeA': ''" @mouseover="showText(5)" @mouseout="hideText()">
        <img v-if="activeIndex === 5" src="./assets/PageCommon/img/quickEntryIcon/qq1.png" >
        <img v-else src="./assets/PageCommon/img/quickEntryIcon/qq.png">
        <p :class="activeIndex === 5 ? 'showP': 'hideP'">客服咨询</p>
      </a>
      <a href="javascript:void(0);" :class="activeIndex === 4 ? 'activeA': ''" @mouseover="showText(4)" @mouseout="hideText()" @click="toTop">
        <img v-if="activeIndex === 4" src="./assets/PageCommon/img/quickEntryIcon/top1.png">
        <img v-else src="./assets/PageCommon/img/quickEntryIcon/top.png">
        <p :class="activeIndex === 4 ? 'showP': 'hideP'">回到顶部</p>
      </a>
    </div>
    <product-compare ref="productCompare" :show-compare="showCompare" @close="closeCompareBox"></product-compare>
  </div>
</template>

<script>
import productCompare from './views/commons/productCompare'
import jdIcon from '@/assets/PageCommon/img/jgIcon.png'
import zkhIcon from '@/assets/PageCommon/img/zkhIcon.png'
import cgIcon from '@/assets/PageCommon/img/cgIcon.png'
import deliIcon from '@/assets/PageCommon/img/deli.jpg'
import floIcon from '@/assets/PageCommon/img/flo.jpg'
import qxIcon from '@/assets/PageCommon/img/qx.jpg'
export default {
  name: 'App',
  components: {
    productCompare
  },
  data () {
    return {
      activeIndex: null,
      showCompare: false,
      showIconFlag: false,
      listImg: [],
      cart: null,
      productList: []
    }
  },
  computed: {
    isUser () {
      return this.$store.state.isUser
    },
    loginStatus () {
      return this.$store.state.loginStatus
    },
    cartGoodNum () {
      return this.$store.state.cartGoodNum
    },
    compareGoodNum () {
      return this.$store.state.compareGoodNum
    }
  },
  watch: {
    isUser (newVal) {
      if (newVal) {
        this.showIconFlag = true
      }
    },
    loginStatus (newVal) {
      if (newVal) {
        this.showIconFlag = true
      }
    },
    showIconFlag (newVal) {
      if (newVal) {
        this.getMyCart()
        this.getCompareBoxInfo()
      }
    }
  },
  created () {
    this.listImg = [jdIcon, zkhIcon, cgIcon, deliIcon, floIcon, qxIcon]
    this.getMyOrderLeftMenu()
  },
  methods: {
    showText (index) {
      this.activeIndex = index
    },
    hideText () {
      this.activeIndex = null
    },
    toTop () {
      document.documentElement.scrollTop = 0
    },
    openCompareBox () {
      this.showCompare = true
    },
    closeCompareBox () {
      this.showCompare = false
    },
    getMyCart () {
      this.get('/previewMyCart.html', {}, (e) => {
        if (e.success) {
          this.cart = e.data.cartInfoVO || {}
          this.$store.state.cartGoodNum = this.cart.totalNumber || 0
        }
      })
    },
    getCompareBoxInfo () {
      const params = {
        memberId: $.data.get('MemberId')
      }
      this.get('/cartcompare/getListByMemberId.html', params, (e) => {
        if (e.success) {
          this.productList = e.data || []
          this.$store.state.compareGoodNum = this.productList.length
        } else {
          $.ui.alert('提示', e.message)
        }
      })
    },
    getMyOrderLeftMenu () {
      this.get('/getMenuTree.html', {}, (e) => {
        if (e.success) {
          let myOrderMenuData = $.data.get('MemberInfo')
          let copyInfo = JSON.parse(JSON.stringify(myOrderMenuData))
          copyInfo.resourceList = e.data
          // this.href(e.data[0].children[0].path)
          $.data.remove('MemberInfo')
          $.data.set('MemberInfo', copyInfo)
        } else {
          $.ui.alert('提示', e.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
#app {
  background-color: rgb(242, 242, 242);
  .quickEntry {
    width: 32px;
    height: 170px;
    position: fixed;
    right: 0;
    bottom: 40px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    a {
      display: block;
      width: 32px;
      height: 32px;
      background: #fff;
      margin-bottom: 2px;
      position: relative;
      span {
        display: inline-block;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        color: rgba(0,0,0,0.65);
        letter-spacing: 0.8px;
      }
      img {
        display: block;
        margin: 4px auto;
      }
      p {
        width: 64px;
        height: 32px;
        margin: 0;
        line-height: 32px;
        text-align: center;
        background: #003388;
        color: #fff;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        position: absolute;
        top: 0;
        left: 32px;
      }
      .showP {
        animation: show 0.5s ;
        left: -64px;
      }
      @keyframes show {
        from {
          -webkit-transform: translate(32px,0);
          transform: translate(32px,0);
        }
        to {
          -webkit-transform: translate(0,0);
          transform: translate(0,0);
        }
      }
      .hideP {
        animation: hide 0.5s ;
      }
      @keyframes hide {
        from {
          opacity: 1;
          -webkit-transform: translate(-32px,0);
          transform: translate(-32px,0);
        }
        to {
          opacity: 0;
          -webkit-transform: translate(0,0);
          transform: translate(0,0);
        }
      }
      i {
        display: inline-block;
        width: 30px;
        height: 16px;
        text-align: center;
        line-height: 16px;
        background: #f00;
        color: #fff;
        border-radius: 8px;
        position: absolute;
        top: 0px;
        left: -22px;
      }
    }
    .activeA {
      background: #003388;
      span {
        color: #fff;
      }
    }
  }
  .quickEntryleft {
    width: 32px;
    height: 170px;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    a {
      display: block;
      width: 32px;
      height: 32px;
      background: #fff;
      margin-bottom: 2px;
      position: relative;
      span {
        display: inline-block;
        width: 32px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        color: rgba(0,0,0,0.65);
        letter-spacing: 0.8px;
      }
      img {
        display: block;
        margin: 4px auto;
      }
      p {
        width: 80px;
        height: 32px;
        margin: 0;
        line-height: 32px;
        text-align: center;
        background: #fff;
        font-weight: bold;
        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
        position: absolute;
        top: 0;
        right: 32px;
      }
      .showP {
        right: -80px;
      }
      @keyframes show {
        from {
          -webkit-transform: translate(32px,0);
          transform: translate(32px,0);
        }
        to {
          -webkit-transform: translate(0,0);
          transform: translate(0,0);
        }
      }
      .hideP {
        animation: hide 0.5s ;
      }
      @keyframes hide {
        from {
          opacity: 1;
          -webkit-transform: translate(-32px,0);
          transform: translate(-32px,0);
        }
        to {
          opacity: 0;
          -webkit-transform: translate(0,0);
          transform: translate(0,0);
        }
      }
      i {
        display: inline-block;
        width: 30px;
        height: 16px;
        text-align: center;
        line-height: 16px;
        background: #f00;
        color: #fff;
        border-radius: 8px;
        position: absolute;
        top: 0px;
        right: -22px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue